module.exports = __webpack_public_path__ + "static/img/gl1300-fcm-sdw360bb.24ee094.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2026/gl1300-fcm-sdw360bb.jpg
// module id = XH/z
// module chunks = 0